import palette from '../palette';
import { colorMappings } from '../palette/colorMappings';
import { generateTheme } from './generateTheme';
import { LIGHT_THEME_MONO_COLORS, LIGHT_THEME_SEMANTIC_COLORS, LIGHT_THEME_SHADOWS } from './themes.constants';
export const MBANK_MASS_SEGMENT_COLORS = {
  primary: palette.brightRedUI,
  primaryDarken: palette.brightRedUIHover,
  primaryContrast: palette.brightRedUI,
  primaryContrastDarken: palette.brightRedUIHover,
  secondary: palette.endeavourBlueUI,
  secondaryDarken: palette.endeavourBlueUIHover,
  secondaryContrast: palette.endeavourBlueUI,
  secondaryContrastDarken: palette.endeavourBlueUIHover,
  ...LIGHT_THEME_MONO_COLORS,
  ...LIGHT_THEME_SEMANTIC_COLORS
};
export const mBank = generateTheme('mBank', 'mass', colorMappings.RETAIL_COLOR_MAPPING, MBANK_MASS_SEGMENT_COLORS, LIGHT_THEME_SHADOWS);